// **  Initial State
const initialState = {
    certifiers: {
        items:[],
        loading:false,
        search:'',
        url:'partners'
    },
    partners: {
        items:[],
        loading:false,
        search:'',
        url:'partners'
    },
    partner: {
        partner:{},
        loading:false
    },
    impact: {
        items:[],
        loading:false,
        search:'',
        url:'impactCriterias'
    },
    material: {
        items:[],
        loading:false,
        search:'',
        url:'materials'
    },
    materialTypes:{
        items:[],
        loading:false,
        search:'',
        url:'materialTypes'
    },
    sharedMaterials:{
      items:[],
      loading:false,
      search:'',
      url:'sharedMaterials'
    },
    impactTypes:{
        items:[],
        loading:false,
        search:'',
        url:'impactCriteriaTypes'
    },
    partnerGroups:{
        items:[],
        loading:false,
        search:'',
        url:'partnerGroups'
    },
    asset:{
        items:[],
        loading:false,
        search:'',
        url:'assets'
    }
}
  
const routeReducer = (state = initialState, action) => {
    switch (action.type) {

        case 'PARTNER_SEARCH':
            return {
                ...state,
                partner: {...state.partner, loading:true, partner:{...state.partner, searched:false}}
            }
        
        case 'PARTNER_SEARCH_SUCCESS':
            
            return {
                ...state,
                partner: {...state.partner, loading:false, partner: {...action.partner, searched:true}}
            }

        case 'PARTNER_SEARCH_FAIL':
            return {
                ...state,
                partner: {...state.partner, loading:false, errors: action.errors}
            }
       
        case 'MATERIAL_TYPES_SEARCH':
            return {
                ...state,
                materialTypes: {...state.materialTypes, loading:true, q: action.q}
            }
        
        case 'MATERIAL_TYPES_SEARCH_SUCCESS':
            
            return {
                ...state,
                materialTypes: {...state.materialTypes, loading:false, items: action.data.results}
            }

        case 'MATERIAL_TYPES_SEARCH_FAIL':
            return {
                ...state,
                materialTypes: {...state.materialTypes, loading:false, errors: action.errors}
            }

        case 'SHARED_MATERIALS_SEARCH':
            return {
                ...state,
                sharedMaterials: {...state.sharedMaterials, loading:true, q: action.q}
            }

        case 'SHARED_MATERIALS_SEARCH_SUCCESS':
            return {
                ...state,
                sharedMaterials: {...state.sharedMaterials, loading:false, items: action.data.results}
            }

        case 'SHARED_MATERIALS_SEARCH_FAIL':
            return {
                ...state,
                sharedMaterials: {...state.sharedMaterials, loading:false, errors: action.errors}
            }

        case 'TABLE_AUTOCOMPLETE':
            return {
                ...state,
                [action.tableType]: {...state[action.tableType], loading:true, q: action.q}
            }
        
        case 'TABLE_AUTOCOMPLETE_SUCCESS':
            
            return {
                ...state,
                [action.tableType]: {...state[action.tableType], loading:false, items: action.data?.results ? action.data?.results : action.data.length > 0 ? action.data : []}
            }

        case 'TABLE_AUTOCOMPLETE_FAIL':
            return {
                ...state,
                [action.tableType]: {...state[action.tableType], loading:false, errors: action.errors}
            }
    

        default:
        return state
    }
}
  
  export default routeReducer
  